'use strict';

import util from './util';
import bonusProductsView from './bonus-products-view';
import samples from './samples';
import progress from './progress';
import ajax from './ajax';
import customDropdown from './custom-dropdown';
import analytics from './analytics';
import gymsharkRecommendation from './pages/product/recommendations';

import modalExport from './modal';
const modal = modalExport.global;

var minicart = {
    init: function () {
        this.$el = $('#mini-cart');
        this.$elMobile = $('#mini-cart-mobile');
        this.$content = this.$el.find('.mini-cart-content');

        // events
        this.$el.find('.mini-cart-total').on('click', function (e) {
            if($('.minicart-link .mini-cart-empty, #mini-cart-mobile .mini-cart-empty').length > 0 ) {
                $('html').removeClass('modal-open')
			} else if($('.pt_cart').length){
                $('html').removeClass('modal-open');
                $('.minicart-overlay').hide();
            } else {
                e.preventDefault();
            }
            if (this.$content.not(':visible')) {
                this.slide();
            }
            $('.utility-link').removeClass('hover');
            $('.dropdown-pane').hide();
            if($('.mini-cart-product').length > 1) {
                $('.scrollbar-inner').trigger("resize.scrollBox");
            }            
        }.bind(this));
        $('.scrollbar-inner').scrollBox();
        setTimeout(adjustMiniCart, 500);
        sessionStorage.setItem('minicartCrossSellTracked','false');
    },

    addProduct: function (data,$addToBagErrorElement) {
        var show = this.show.bind(this);
        var $qtyfield = $('.product-form-actions');
        var qtyVal = $qtyfield.find('select[name="Quantity"]');
        var MMProduct = (data.MMProduct) ? data.MMProduct : false;

        return new Promise(function (resolve, reject) {
            if (data.hasOwnProperty("pid") === false) {
                return reject();
            }

            $.post(util.appendParamsToUrl(Urls.addProduct, {
                "format": "ajax",
                "pid": encodeURIComponent(data.pid),
                "Quantity": data.hasOwnProperty("Quantity") ? data.Quantity : ( qtyVal != '' && qtyVal != undefined) ? qtyVal.val() : "1",
                "MMProduct": MMProduct
            }), function (data) {
                if (data.success === false) {
                	$addToBagErrorElement.html(data.error).removeClass("hide");
                	return reject(data.error);
                }

                show(data, MMProduct);
                minicartRecommendations();
                resolve();
            }).fail(function (err) {
                reject(err.error);
            });
        });
    },

    addAllToWishlistFromContent: function (pids) {
        return window.location.href = Urls.addAllFromContent
                + "?pid=" + pids.join(":1,") // pass qty of one
                + "&cid=" + window.contentAssetID
                + "&hashparam=" + window.location.hash.split('#')[1];
    },

    addAllProducts: function (pids, to, $addToBagErrorElement) {
        if (!pids || pids.length === 0) {
            return;
        }

        var isWishlist = (to && to.toLowerCase() === "wishlist");
        if (isWishlist && !window.User.isCustomerAuthenticated) {
            if (window.contentAssetID) {
                return this.addAllToWishlistFromContent(pids);
            } else {
                var footerURL = $('footer') ? $('footer').data('url') : null;
                window.location = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
                return;
            }
        }

        var show = this.show.bind(this);
        var urlName = Urls.addMultipleProducts;

        if (isWishlist) {
            urlName = Urls.wishlistAddAll.split(window.location.hostname)[1];
        }

        $.post(util.appendParamsToUrl(urlName, {
            format: 'ajax',
            pid: pids
        }), function (data) {
            if (isWishlist) {
                window.location.href = window.location.href;
                return;
            }
            if (data) {
                if (data.success === false) {
                    if($addToBagErrorElement.length) {
                        $addToBagErrorElement.html(data.error).removeClass('hide');
                        gymsharkRecommendation.crosssellRecommendationModal();
                    }
                    return;
                } else {
                    if($addToBagErrorElement.length) {
                        $addToBagErrorElement.html('').addClass('hide');
                    }
                    show(data);
                    gymsharkRecommendation.crosssellRecommendationModal();
                }
            }
        });
    },


    updateProduct: function (data) {
		$('.mini-cart-products .ajax-loader').show();
        return new Promise(function (resolve, reject) {
            $.post(util.appendParamsToUrl(data.dataRedirectUrl, {
                "format": "ajax",
                "pid": encodeURIComponent(data.pid),
                "Quantity": data.hasOwnProperty("Quantity") ? data.Quantity : "1"
            }), function (data) {
                if (data.success === false) {
                    return reject(data.error);
                }
				if (data) {
					$('.minicart-link').html(data);
                    $('#mini-cart-mobile').html(data);
                    $('#mini-cart-mobile .mini-cart-content').addClass('qtyopenedupdate');
					$('.minicart-link .mini-cart-content').addClass('qtyopenedupdate');
					$('select.minicart-quantity-dropdown').selectmenu();
                    util.paraEndWithThreeDots($('.mini-cart-details .mini-cart-name strong'), 50, 38);
                    minicartRecommendations();
					minicartCartIconRedirect();
					updateQuantityOnChange();
					$('.minicart-link .scrollbar-inner').scrollBox();
                    $('#mini-cart-mobile .scrollbar-inner').scrollBox();
				}
                resolve();
            }).fail(function (err) {
                reject(err.error);
            });
        });
    },
    
    addSetProducts :  function (e) {
        e.preventDefault();
        var $pidData = $('.product-set-list').find('form').length > 0 ? $('.product-set-list').find('form') : '';
        var $addToBagErrorElement = $(".miniproduct-actions .global-add-to-bag .global-add-to-cart-error");
        if($pidData != '') {
            return $pidData.toArray().map(function (ele) {
                var $qtyfield = $('.product-form-actions-set');
                var qtyVal = $qtyfield.find('select[name="Quantity"]');
                var $ele = $(ele),
                    pid = $ele.data('pid'),
                    qty = $ele.find('select[name="Quantity"]').length ? $ele.find('select[name="Quantity"]').val() : (qtyVal != '' && qtyVal != undefined) ? qtyVal.val() : "1";
                minicart.addProduct({pid: pid,Quantity:qty},$addToBagErrorElement);
                return pid + ":" + qty;
            }).join(',');
        }
    },

    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html, isMMEvent) {
    	// re-fetch mini-cart object

    	if (!this.$el) {
    		this.$el = $('#mini-cart');
    	}
    	if (!this.$elMobile) {
    		this.$elMobile = $('#mini-cart-mobile');
    	}

        this.$el.html(html);
        this.$elMobile.html(html);
        if(isMMEvent && typeof(mmDLData) != 'undefined' && mmDLData) {
            window.dataLayer.push(mmDLData);
        }

       
        this.init();
        if (!$('#dialog-ai-container[data-modal-state="MESSAGES_VIEW"]').length) {
            this.slide();
        }

        // identify if we can show the sample overlay
        var canShowSamples = false;
        $(document).find('#mini-cart input[name="eligible-for-sample"]').each(function() {
        	if (!canShowSamples && $(this).val() == 'true') {
        		canShowSamples = true;
        	}
        });
        
        /*
        if ((bonusProductsView.hasBonusOptions() === false && samples.canShowSelection())
        		&& canShowSamples) {
        	setTimeout(function() { 
                samples.showSelection(); 
            }, 1000);
 
        }
        */
        $('select.minicart-quantity-dropdown').selectmenu();
        updateQuantityOnChange();
		util.paraEndWithThreeDots($('.mini-cart-details .mini-cart-name strong'), 50, 38);
		minicartCartIconRedirect();
        // Wait until sb-container content exists
        util.waitForElement('.minicart-link .sb-container .sb-content').then(() => {
            $('.minicart-link .sb-container .sb-content').removeAttr('style');
            $(window).trigger('resize.scrollBox');

            // Wait for minicart recommendations (Slick) to initialize
            return minicartRecommendations();
        })
        .then(($recommendations) => {
            // Wait for truly visible slides
            return util.getTrulyVisibleSlides($('.minicart-recommendation-container'));
        })
        .catch((err) => {
            console.warn('Minicart show error:', err);
        });
		setTimeout(() => {
			if ($('.minicart-link .sb-container .sb-content').length === 0) {
			$('.minicart-link .sb-container').scrollBox();
		} else {
			$('.minicart-link .sb-container .sb-content').removeAttr('style');
			$(window).trigger('resize.scrollBox');
		}
		}, 1000);
        
        bonusProductsView.loadBonusOption();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        // show the item
        if(this.$content.length){
        	this.$el.addClass('minicart-open');
            $('select.minicart-quantity-dropdown').selectmenu();
            if(localStorage.cartModalOpen === 'miniCartOpen') {
                analytics.cartModalClose();
                localStorage.removeItem('cartModalOpen');
            }
        }

        this.$elMobile.find('.mini-cart-content').effect(
            'slide', { direction: 'right', mode: 'show' }
        ,500);
        
        this.$content.effect(
            'slide', { direction: 'right', mode: 'show' }, 
        500);

        var displayStyle = $('#mini-cart-mobile .mini-cart-content').css('display');

        // Check if the display style is "block"
        if (displayStyle === 'block') {
            $('#mini-cart-mobile').addClass('minicart-open');
            $('.crosssell-recommendation-modal').addClass('active');
            $('html').addClass('overflow-hidden')
        }
        analytics.minicartProductList();
        this.$content.attr('aria-expanded', true);
    },
    close: function (delay) {
		$('.minicart').removeClass('confirmation-active');
		$('body').removeClass('add-to-confirmation')
		$('.minicart,#mini-cart-mobile').removeClass('minicart-open').addClass('minicart-close');
        $('.crosssell-recommendation-modal').removeClass('active');
		$('html').removeClass('filter-open');
        $('html').removeClass('overflow-hidden')
	},
    remove: function (pid) {
        $('.mini-cart-products .ajax-loader').show();
		$.post(util.appendParamsToUrl(Urls.removeProduct, {
			"format": "ajax",
			"pid": pid
		}), function (data) {
			if (data) {
                $('.mini-cart-content').parent('.minicart-wrapper').html(data);
                $('.sb-container').scrollBox();
                minicart.init();
                updateQuantityOnChange();
                $('.minicart-link .mini-cart-content').addClass('qtyopenedupdate');
                $('#mini-cart-mobile .mini-cart-content').addClass('qtyopenedupdate');
                $('select.minicart-quantity-dropdown').selectmenu();
                util.paraEndWithThreeDots($('.mini-cart-details .mini-cart-name strong'), 50, 38);
                minicartRecommendations();
                minicartCartIconRedirect();
                if($('.cart-body').length) {
                    window.location.reload();
                }
			}
		}).fail(function (err) {
			reject(err.error);
		});
	},
    addBonusProduct: function (pid,bliUUID) {
		$('.mini-cart-products .ajax-loader').show();
		$.post(util.appendParamsToUrl(Urls.addBonusProductsAJAX, {
			"format": "ajax",
			"pid": pid,
			"bliUUID": bliUUID,
			"minicart": "minicart"
		}), function (data) {
			if (data) {
                $('.mini-cart-content').parent('.minicart-wrapper').html(data);
                $('.sb-container').scrollBox();
                minicart.init();
                updateQuantityOnChange();
                $('.minicart-link .mini-cart-content').addClass('qtyopenedupdate');
                $('#mini-cart-mobile .mini-cart-content').addClass('qtyopenedupdate');
                $('select.minicart-quantity-dropdown').selectmenu();
                util.paraEndWithThreeDots($('.mini-cart-details .mini-cart-name strong'), 50, 38);
                minicartRecommendations();
                minicartCartIconRedirect();
                analytics.addBonusProductMinicartDataLayer(pid);
                gymsharkRecommendation.crosssellRecommendationModal();
                if($('.cart-body').length) {
                    $('.minicart-wrapper .mini-cart-content').hide();
                    window.location.reload();
                }
			}
		}).fail(function (err) {
			reject(err.error);
		});
	},
    
    addProductFromRecomendation : function (pid, qty, cartAction, prodContainer, e) {
        $('.mini-cart-products .ajax-loader').show();
        const $data = {
            "format": "ajax",
            "pid": pid,
            "Quantity": qty,
            "cartAction": cartAction,
            "source":'minicartrecomendation'
        }
        $.post(Urls.addProduct, $data, function (data) {
            if (data.error) {
                $('.mini-cart-products .ajax-loader').hide();
                let $errEle = $(".minicart-recommendations .slick-active #a2c-error-crosssell");
                $errEle.html(data.error).slideDown('fast', function () {
                    setTimeout(function () {
                        $errEle.slideUp(500, function () {
                            $(this).removeClass('active');
                        });
                    }, 2000);
                });
                
            } else {
                $('#mini-cart, #mini-cart-mobile').html(data);
                analytics.minicartCrossSellAddToCart(prodContainer, e);
                minicart.init();
                util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
                minicartRecommendations();
                minicartCartIconRedirect();
                updateQuantityOnChange();
                gymsharkRecommendation.crosssellRecommendationModal();
                $('.minicart-link .sb-container, #mini-cart-mobile .sb-container').scrollBox();
            }
        }).fail(function (err) {
            reject(err.error);
        });
    },

    updateQuantityOnChange: updateQuantityOnChange(),
    minicartCartIconRedirect: minicartCartIconRedirect()
};

$(".mini-cart-link").click(function() {
	$('.menu-utility-content').removeClass('is-open');
	$('.utility-link').removeClass('hover');
});

$(".mini-cart-link-cart").click(function() {
    var redirectTo = $(this).attr('href');
    window.location.href = redirectTo;
})

$('.minicart-link').on('click', function (e) {
	var $minicartLink = $('.minicart-link');
    minicartRecommendations();
	if ($(window).width() > 991){
		$('.minicart').removeAttr('style');
		if ($('.minicart-link .sb-container .sb-content').length === 0) {
			$('.minicart-link .sb-container').scrollBox();
		} else {
			$('.minicart-link .sb-container .sb-content').removeAttr('style');
			$(window).trigger('resize.scrollBox');
		}
	//$minicartLink.find('.minicart').removeClass('closed').addClass("opened"); // minicart slide panel open
	util.paraEndWithThreeDots($('.mini-cart-details .mini-cart-name strong'), 50, 38);
	minicartCartIconRedirect();
    gymsharkRecommendation.crosssellRecommendationModal();
	}
});

function detectMinicartCrosssellCall() {
    const $crosssellSlot = $('.mini-cart-crosssell-slot > div');
    if ($crosssellSlot.length === 0) return;
    const targetNode = $crosssellSlot.get(0);
    if (!(targetNode instanceof Node)) return;
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            // Only look at newly added nodes
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.classList.contains('minicart-recommendation-container')) {
                    minicartRecommendations();
                }
            });
        });
    });

    observer.observe($crosssellSlot[0], { 
        childList: true,
        subtree: false
    });
}

function adjustMiniCart() {
    const isDesktop = $(window).width() > 991;

    const container = isDesktop
        ? '.minicart-link'
        : '#mini-cart-mobile';

    const $header = $(`${container} .mini-cart-header`);
    const $footer = $(`${container} .mini-cart-totals`);
    const $products = $(`${container} .mini-cart-products`);
    const $message = $(`${container} .incentive-message-container`);

    const headerHeight = $header.outerHeight() || 0;
    const footerHeight = $footer.outerHeight() || 0;
    const messageHeight = $message.outerHeight() || 0;
    const availableHeight = $(window).outerHeight() - (headerHeight + footerHeight + messageHeight + 12);

    $products.css({
        marginBottom: footerHeight,
        maxHeight: availableHeight,
        minHeight: availableHeight,
    });
}

function minicartCartIconRedirect() {
    var displayStyle = $('#mini-cart .mini-cart-content').css('display');
	if ($(window).width() > 991 && !$('.pt_cart').length && displayStyle !== 'block') {
		$('.minicart-link .mini-cart-link')
            .off('click.minicartRedirect')
            .on('click.minicartRedirect', function(e) {
			if($('.minicart-link .mini-cart-empty').length > 0 && !$('.pt_cart').length) {
                $('html').removeClass('modal-open')
			} else {
				e.preventDefault();
            }
		});
	}
    setTimeout(adjustMiniCart, 500);
	
}

function syncQtyDropdownValue($dropdownElem) {
	$dropdownElem.on('selectmenuchange change', function (e) {
		var dataPID = $(this).parents('.mini-cart-product').data('pid');
		var dataRedirectUrl = $(this).parents('.mini-cart-product').data('redirecturl');
		$(this).val($(this).val());
		$(this).selectmenu({
			positionOptions: {
				collision: 'none'
			}
		}).selectmenu('refresh');
		minicart.updateProduct({Quantity : Math.trunc($(this).val()), pid : dataPID, dataRedirectUrl : dataRedirectUrl});
	});
    
    setTimeout(() => {
        if ($('.minicart-link .sb-container .sb-content, #mini-cart-mobile .sb-container .sb-content').length === 0 && $('.minicart-link .mini-cart-empty, #mini-cart-mobile .mini-cart-empty').length == 0) {
            $('.minicart-link .sb-container, #mini-cart-mobile .sb-container').scrollBox();
            $('mini-cart-products').removeClass('scrollbar-inner');
    } else {
        $('.minicart-link .sb-container .sb-content, #mini-cart-mobile .sb-container .sb-content').removeAttr('style');
        $(window).trigger('resize.scrollBox');
    }
    }, 1000);
    if ($('.minicart-link .mini-cart-empty, #mini-cart-mobile .mini-cart-empty').length) {
        $('.minicart-link, #mini-cart-mobile').removeClass('minicart-open');
        $('.minicart-link, #mini-cart-mobile').addClass('minicart-close');
        $('html').removeClass('overflow-hidden');
        $('.crosssell-recommendation-modal').removeClass('active');
    }
	$('.minicart-Pricing-wrapper #minicart-quantity-button').on('click', function (e) {
		$('.mini-cart-product').removeAttr('style');
		$(this).closest('.mini-cart-product').css('z-index', 2);
	});
}

function updateQuantityOnChange() {
	var $quantityDropdown = $('.minicart-quantity-dropdown')
	$quantityDropdown.selectmenu({
		positionOptions: {
			collision: 'none'
		}
	});
    sessionStorage.setItem('minicartCrossSellTracked','false');
	syncQtyDropdownValue($quantityDropdown);
}

$(document).on('click', '.mini-cart-header .minicart-close', function () {
    this.$el = $('#mini-cart');
    this.$elMobile = $('#mini-cart-mobile');
    this.$content = this.$el.find('.mini-cart-content');
    this.$content.effect('slide', { direction: 'right', mode: 'hide' }, 600);
    this.$el.removeClass('minicart-open');
    this.$elMobile.removeClass('minicart-open');
    $('html').removeClass('overflow-hidden');
    $('html').removeClass('modal-open');
    $('.crosssell-recommendation-modal').removeClass('active');
    if(localStorage.cartModalOpen === 'miniCartOpen') {
        analytics.cartModalClose();
        localStorage.removeItem('cartModalOpen');
    }
    this.$content.attr('aria-expanded', false);
    this.$elMobile.find('.mini-cart-content').effect('slide', { direction: 'right', mode: 'hide' }, 500);
    var displayStyle = $('#mini-cart-mobile .mini-cart-content').css('display');

    // Check if the display style is "block"
    if (displayStyle === 'none') {
        $('#mini-cart-mobile').addClass('minicart-close')
    }

    if(localStorage.cartModalOpen === 'miniCartOpen') {
        analytics.cartModalClose();
        localStorage.removeItem('cartModalOpen');
    }
}).on('click', '.mini-cart-content .mini-cart-details .remove-link', function () {
    minicart.remove($(this).data('pid'));
    $('#mini-cart-mobile .mini-cart-content').addClass('qtyopenedupdate');
}).on('click', '.minicart-overlay', function(){
	$('.minicart-link .minicart-close').trigger('click');
	$('html').removeClass('modal-open');
	$('.mini-cart-products').removeAttr('style');
    $('html').removeClass('overflow-hidden');
}).on('click', 'button[name$="addBonusProduct"]', function(){
	var pid = $(this).data('pid');
	var bliUUID = $(this).data('bliuuid');
	minicart.addBonusProduct(pid,bliUUID);
}).on('click', '.mini-cart-crosssell-slot .custom-dd .custom-dd-list-item', function () {
	// Handles the selection of a product tile in the minicart cross sell slot. 
	const $this = $(this);
	const pid = $(this).find('.color-swatch, .swatchanchor').data('pid');
	const targetContainer = $this.parents('.minicart-recommendations-tile');

	const params = {
		format: 'ajax',
		pid: pid,
		templaterender: 'product/minicartcrosssell',
		showswatches: true,
		showpricing: true,
		showpromotion: true,
		isclickable: true,
		showrating: true,
		disablebvseo: true,
		showbrandname: true,
		issliderimage: false,
		source: "MinicartCrosssell",
		isminicartcrosssell: true
	};

	ajax.load({
		url: util.appendParamsToUrl(Urls.transactionalHitTile, params),
		target: targetContainer,
		callback: function () {
			customDropdown.init();
            sessionStorage.setItem('minicartCrossSellTracked','false');
            analytics.minicartCrossSellafterInit($('.minicart-recommendations'));
		},
	});
	
}).on('click', '.minicart-recommendations-tile .add-to-cart', function(e){
		const $this = $(this);
		const pid = $this.data('pid');
		const qty = $this.data('quantity');
		const cartAction = $(this).data('cartaction');
		const prodContainer = $this.closest('.minicart-recommendations-tile');
		minicart.addProductFromRecomendation(pid, qty, cartAction, prodContainer, e);
});

// product level bonus modal
$(document).on('click', '.bonus-item-promo a.select-bonus', function (e) {
    e.preventDefault();
    e.stopPropagation();
    //to prevent duplication this should not trigger for cart page
    if(!$('.pt_cart').length) {
        var urlToRender = $(this).attr('href');
    }

    if (urlToRender) {
        modal.addCustomClass('bonus-item-modal bonus-item-modal-redesign');
        modal.setCallback(function () {
            if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length <=  6) {
                $('.reveal#modal-cntr').addClass('modal-cntr-noscroll');
                if($(window).width() < 768) {
                    if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length < 4) {
                        $('.reveal .product-listing').addClass('product-listing-noscroll');
                    } else {
                        $('.reveal .product-listing').scrollBox();
                        setTimeout(() => {
                            $('.reveal .product-listing').trigger('resize.scrollBox');
                        },  500);
                    }
                } else {
                    $('.reveal .product-listing').addClass('product-listing-noscroll');
                }

                if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 1) {
                    $('.reveal#modal-cntr').addClass('modal-cntr-onesample');
                } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 2) {
                    $('.reveal#modal-cntr').addClass('modal-cntr-two-sample');
                } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 3) {
                    $('.reveal#modal-cntr').addClass('modal-cntr-three-sample');
                } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 4) {
                    $('.reveal#modal-cntr').addClass('modal-cntr-four-sample');
                } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length > 4) {
                    $('.reveal#modal-cntr').addClass('modal-cntr-five-sample');
                }
            } else {
                $('.reveal .product-listing').scrollBox();
                setTimeout(() => {
                    $('.reveal .product-listing').trigger('resize.scrollBox');
                }, 500);
                $('.reveal#modal-cntr').addClass('modal-cntr-five-sample');
            }
            setTimeout(() => {
                if($('.reveal .sample-popup-header').height() > 20) {
                    $('.reveal .product-listing').addClass('sample-popup-header__two-lines')
                }
            }, 500);
        });
        $('.bonus-item-modal').parent('.reveal-overlay').addClass('bonus-overlay');
        modal.renderByUrl(urlToRender);
    }
});

/**
 * Initializes the minicart recommendations carousel and related UI once the container is available.
 *
 * - Waits for `.minicart-recommendation-container .minicart-recommendations`.
 * - Applies Slick with configured options and responsive behavior; skips if already initialized.
 * - Initializes custom dropdowns and updates minicart layout/cart icon behavior.
 */
const minicartRecommendations = function () {
    // Move focus into the panel
    $('.mini-cart-header h2').focus();

    if ($('.mini-cart-crosssell-slot').length) {
        if ($(window).width() < 991) {
            $('.minicart-desktop .mini-cart-crosssell-slot').empty();
        } else {
            $('#mini-cart-mobile .mini-cart-crosssell-slot').empty();
        }
    }
    detectMinicartCrosssellCall();
    return new Promise(function (resolve, reject) {
        util.waitForElement('.minicart-recommendation-container .minicart-recommendations')
            .then(function ($recommendations) {
                // If Slick is already initialized
                if ($recommendations.hasClass('slick-initialized')) {
                    customDropdown.init();
                    minicartCartIconRedirect();
                    resolve($recommendations);
                    setTimeout(function () {
                        $recommendations.slick('refresh');
                    }, 500);
                } else {
                    // Initialize Slick
                    
                    // Use a timeout fallback in case init event doesn't fire
                    let resolved = false;

                    $recommendations.one('init', function () {
                        if (!resolved) {
                            resolved = true;
                            customDropdown.init();
                            minicartCartIconRedirect();
                            resolve($recommendations);
                            analytics.minicartCrossSellafterInit($recommendations);
                        }
                    });
                    $recommendations.slick({
                        initialSlide: 0,
                        autoplay: false,
                        dots: true,
                        arrows: true,
                        infinite: false,
                        speed: 150,
                        slidesToShow: 1,
                        fade: false,
                        cssEase: 'linear',
                        centerMode: false,
                        nextArrow: '<div class="slick-next"><i class="icon icon-rightCarrot"></i></div>',
                        prevArrow: '<div class="slick-prev"><i class="icon icon-leftCarrot"></i></div>'
                    });

                    $recommendations.find('.slick-slide:last').addClass('last-slide');

                    // Fallback: resolve after a small delay anyway
                    setTimeout(function () {
                        if (!resolved) {
                            resolved = true;
                            customDropdown.init();
                            minicartCartIconRedirect();
                            resolve($recommendations);
                            analytics.minicartCrossSellafterInit($recommendations);
                        }
                    }, 100);
                }
                $recommendations.on('click', '.product-image, .product-info-text', function (e) {
                    e.preventDefault();
                    const $this = $(this);
                    if($recommendations.find('div[id^="cq_recomm_slot"]').length) {
                        return;
                    }
                    const redirectLink =  $this.find('.pdp-link').first().attr('href');
                    if (!redirectLink) return;
                    if (e.ctrlKey || e.metaKey) {
                        window.open(redirectLink, '_blank', 'noopener');
                    } else {
                        window.location.href = redirectLink;
                    }
                });
            })
            .catch(function (err) {
                console.warn('Error in minicartRecommendations:', err);
                reject(err);
            });
    });
};

minicartCartIconRedirect();
updateQuantityOnChange();
minicart.updateQuantityOnChange = updateQuantityOnChange;

export default minicart;
